const getSectionsData = sections =>
  sections.map(section => {
    const { props: { component: { settings: { label, name } = {} } = {} } = {} } = section;
    return [encodeURI(name), label];
  });

export default getSectionsData;
